<div
  class="lay-content"
[ngClass]="{
  'lay-content': true,
  'is-direction-row': direction() === 'row',
  'is-direction-column': direction() === 'column'}">
  <ng-content></ng-content>
</div>
@if (!(userAgent.isNativeApp() && userAgent.isAndroid()) && !showSpinner) {
  <app-icon class="navigation-icon text-24"  name="chevron-navigation" />
}
@if (showSpinner) {
  <lay-button>
    <button
      class="is-loading">
    </button>
  </lay-button>
}
